import { createContext, useContext } from "react";
import { type ItemSelectQuery } from "./item-select-utils";

export type ItemSelectContextState = {
  activeItemId?: string | null;
  disabled?: boolean;
  items?: ItemSelectQuery["items"];
};

export const defaultItemSelectContextState: ItemSelectContextState = {
  items: [],
};

export const ItemSelectStateContext = createContext<ItemSelectContextState>(
  defaultItemSelectContextState,
);
export const useItemSelectState = () => useContext(ItemSelectStateContext);
